import React, { useState } from "react";
import Typography from "./Typography/Typography";
import { styled } from "styled-components";
import { Col, Container, Row } from "react-bootstrap";
import { data } from "../Data/data";
import ButtonComp from "./ButtonComp";
import Svg from "../assets/Svgs/Svg";
import { ErrorMessage, Field, Formik, Form as FormContainer } from "formik";
import { useApp } from "../hooks/useApp";
import WitmatesServices from "../http/witmates.service";
import Loading from "./Loading";
import { Link } from "react-router-dom";

export default function GetQuoteToday({ onModalClose }) {
   const { _getQuoteTodaySchema, _getInTouchApi } = new WitmatesServices();
   const [fileInfo, setFileInfo] = useState(null);
   const [dataUrl, setDataUrl] = useState(null);
   const { setPopup } = useApp();
   const [loading, setLoading] = useState(false);

   const documentOnUpload = (e) => {
      const file = e.target.files[0];
      if (file) {
         setFileInfo(file);
         const reader = new FileReader();
         reader.onload = (event) => {
            const dataUrl = event.target.result;
            setDataUrl(dataUrl);
         };
         reader.readAsDataURL(file);
      }
   };

   const onSubmit = (values, action) => {
      let formData = new FormData();
      formData.append("contact[name]", `${values.name}`);
      formData.append("contact[email]", values?.email);
      formData.append("contact[phone]", values?.phone_number);
      formData.append("contact[message]", values?.requirements);
      formData.append("contact[requirement_type]", values?.requirement_type);
      dataUrl && formData.append("contact[document]", dataUrl);
      values?.services.forEach((element, idx) => {
         formData.append("contact[services][]", element);
      });
      _getInTouchApi(formData, (loading, data, error) => {
         setLoading(loading);
         if (data) {
            onModalClose();
            setPopup({
               isOpen: true,
               content: (
                  <>
                     <span style={{ color: "#FF5101" }}>Thank you</span>, we’ll <br /> be in touch soon.
                  </>
               ),
               cb: () => console.log("modal work"),
            });
         }
         if (error) console.log(error);
      });
   };
   return (
      <>
         <div className="p-3 p-md-5" style={{ background: "#000000" }}>
            <Typography element="span" className="font-43 font-md-30 mt-3" color="white" fontWeight={400} DMSans>
               Get a <span style={{ color: "#FF5101" }}>Quote</span> Today...
            </Typography>
            <div className="mt-4">
               <Loading loading={loading} size="5px" color="#bdbdbd" height="30vh" background="black">
                  <Formik initialValues={{ name: "", email: "", phone_number: "", requirements: "", services: [] }} onSubmit={onSubmit} validationSchema={_getQuoteTodaySchema}>
                     {(formik) => {
                        return (
                           <FormContainer>
                              <Container>
                                 <Row>
                                    <Col xs={12} className="py-4">
                                       <span className="text-white">Fill out our quick and easy form to get a free quote from our team of experts.</span>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={6} className="p-2">
                                       <Field as={Input} name="name" type="text" className="input" placeholder="YOUR NAME*" />
                                       <ErrorMessage component="small" className="text-error" name="name" />
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={6} className="p-2">
                                       <Field as={Input} type="text" name="email" className="input" placeholder="YOUR EMAIL ADDRESS*" />
                                       <ErrorMessage component="small" className="text-error" name="email" />
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} className="p-2">
                                       <Field as={Input} type="text" name="phone_number" className="input" placeholder="CONTACT NUMBER*" />
                                       <ErrorMessage component="small" className="text-error" name="phone_number" />
                                    </Col>
                                    <Col xs={12}>
                                       <Field as={Textarea} name="requirements" placeholder="Share your requirements with us*" />
                                       <ErrorMessage component="small" className="text-error" name="requirements" />
                                    </Col>
                                    <Col xs={12} sm={12} md={12} className="p-2">
                                       <div className="container-fluid">
                                          <div className="row pt-2 g-2">
                                             <div className="col-12 pt-3">
                                                <Typography element="span" className="font-17" color="#bdbdbd">
                                                   Services
                                                </Typography>
                                             </div>
                                             {data.services.map((item, idx) => (
                                                <React.Fragment key={`popup-services-${idx}`}>
                                                   <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                                                      <label htmlFor={`services-${idx + 1}`} className="d-flex align-items-center text-white">
                                                         <Field //
                                                            as={Checkbox}
                                                            type="checkbox"
                                                            className="checkbox"
                                                            name={`services`}
                                                            value={item.replace("--", "").toLowerCase()}
                                                            id={`services-${idx + 1}`}
                                                         />
                                                         <span>&nbsp;&nbsp;{item.replace("--", "")}</span>
                                                      </label>
                                                   </div>
                                                </React.Fragment>
                                             ))}
                                             <div className="col-12 pt-3">
                                                <Typography element="span" className="font-17" color="#bdbdbd">
                                                   Requirement Type
                                                </Typography>
                                             </div>
                                             <div className="col-auto px-3">
                                                <label htmlFor="project_basis" className="d-flex align-items-center text-white">
                                                   <Field as={Radio} type="radio" name="requirement_type" value="project basis" id="project_basis" />
                                                   <span>&nbsp;&nbsp;Project Basis</span>
                                                </label>
                                             </div>
                                             <div className="col-auto px-3">
                                                <label htmlFor="staffing_needs" className="d-flex align-items-center text-white">
                                                   <Field as={Radio} type="radio" name="requirement_type" value="staffing needs" id="staffing_needs" />
                                                   <span>&nbsp;&nbsp;Staffing Needs</span>
                                                </label>
                                             </div>
                                             <div className="col-auto px-3">
                                                {/* file uploader */}
                                                <label htmlFor="x" className="text-white d-block">
                                                   <span className="text-uppercase cursor-pointer">{Svg.attach_file}&nbsp;Upload documents (optional)</span>
                                                   <input type="file" id="x" hidden onChange={documentOnUpload} accept=".pdf" />
                                                </label>
                                                {/* file uploader */}
                                             </div>
                                             {fileInfo && (
                                                <div className="col-12 pt-3">
                                                   <Typography element="span" className="font-17" color="#bdbdbd">
                                                      Documents
                                                   </Typography>
                                                   <div style={{ color: "#ff5101" }}>
                                                      {fileInfo?.name}{" "}
                                                      <button
                                                         className="btn text-danger"
                                                         onClick={() => {
                                                            setFileInfo(null);
                                                            setFileInfo(null);
                                                         }}>
                                                         X
                                                      </button>
                                                   </div>
                                                </div>
                                             )}
                                          </div>
                                       </div>
                                    </Col>
                                    <Col xs={12} className="py-4">
                                       <Link to="/privacy-policy">
                                          <span className="text-white">
                                             By clicking the submit button you agree to our <span style={{ color: "#FF5101" }}> <Link to="/privacy-policy" className="text-white">Privacy Policy</Link></span> terms.
                                          </span>
                                       </Link>
                                    </Col>
                                    <Col xs={12} className="py-4">
                                       <ButtonComp title="SUBMIT" inputProps={{ type: "submit" }} isDefaultWhite />
                                    </Col>
                                 </Row>
                              </Container>
                           </FormContainer>
                        );
                     }}
                  </Formik>
               </Loading>
            </div>
         </div>
      </>
   );
}
const Checkbox = styled.input`
   width: 14px !important;
   height: 18px !important;
   border: 1px solid white;
   background-color: #000000;
   cursor: pointer;
   appearance: none;
   position: relative;
   &::before {
      content: "✔";
      color: white;
      width: 22px !important;
      height: 18px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ff5101;
      font-size: 18px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;
      transition: opacity 0.2s;
   }
   &:checked::before {
      opacity: 1;
   }
`;
const Input = styled.input`
   height: auto !important;
   border: none;
   border-bottom: 1px solid white;
   background-color: #000000;
   color: white;
   width: 100%;
   padding-top: 13px;
   &::placeholder {
      color: #bdbdbd;
   }
   &:focus {
      outline: none;
   }
`;

const Radio = styled.input`
   appearance: none;
   position: relative;
   margin: 0;
   width: 18px;
   height: 23px;
   border: 2px solid #ff5101;
   border-radius: 50%;
   transition: all 0.1s ease-in-out;
   &:checked::after {
      content: "●";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      color: #ff5101;
   }
`;

const Textarea = styled.textarea`
   border: none;
   border-bottom: 1px solid white;
   background-color: #000000;
   color: white;
   width: 100%;
   padding-top: 16px;
   &::placeholder {
      color: #bdbdbd;
      text-transform: uppercase;
   }
   &:focus {
      outline: none;
   }
`;
